import { formatCardNumber } from '~/shared/lib/formatters/formatCardNumber';
import { formatPhoneNumber } from '~/shared/lib/formatters/formatPhoneNumber';
import { type Currency } from '../../../currency';
import { paymentMethods, publicStatuses } from '../constants';
import { Bank, type PublicStatus, type PaymentMethod, type PaymentType } from '../model';

export const formatOrder = {
    date: (dateString?: string) => {
        if (!dateString) {
            return '';
        }

        return new Date(dateString).toLocaleString();
    },
    bank: (bank?: Bank) => {
        if (!bank) {
            return '';
        }

        if (typeof bank !== 'string') {
            return 'BIN банка не определен';
        }

        if (bank === Bank.BANK_UNSPECIFIED) {
            return 'Не указан';
        }

        return bank.replace('BANK_', '').replaceAll('_', ' ');
    },
    banks: (banks?: Bank[]) => {
        if (!banks) {
            return '';
        }

        if (banks.length === 1 && banks[0] === Bank.BANK_UNSPECIFIED) {
            return 'Не указаны';
        }

        const specifiedBanks = banks.filter((bank) => {
            return bank !== Bank.BANK_UNSPECIFIED;
        });

        return specifiedBanks
            ?.map((bank) => {
                return formatOrder.bank(bank);
            })
            .join(', ');
    },
    method: (method?: PaymentMethod) => {
        if (!method) {
            return '';
        }

        const { label } =
            paymentMethods.find((p) => {
                return p.value === method;
            }) ?? {};

        return label;
    },
    publicStatus: (status: PublicStatus) => {
        const { label } =
            publicStatuses.find((p) => {
                return p.value === status;
            }) ?? {};

        return label;
    },
    currency: (currency?: Currency) => {
        if (!currency) {
            return '';
        }

        return currency.replace('CURRENCY_', '');
    },
    cardNumber: formatCardNumber,
    phoneNumber: formatPhoneNumber,
    type: (type: PaymentType) => {
        return type.replace('TYPE_', '').replaceAll('_', ' ');
    },
} as const;
